import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { TicketApp } from './TicketApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <TicketApp />
);

